import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/config";

export default function WhatsAppButton() {
  return (
    <a
      href={waLink("Hello Kanan Remedies, I'd like to place a wholesale order for my pharmacy / clinic.")}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 left-6 z-[65] flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5B] text-white font-bold text-sm pl-3 pr-4 py-3 rounded-full shadow-xl transition-all duration-300 hover:scale-105 active:scale-95"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline">Order on WhatsApp</span>
    </a>
  );
}
